import React, { useState, useEffect } from 'react'
import {
  Form,
  Input,
  Button,
  Radio,
  Select,
  Checkbox,
  message,
} from 'antd';
import { useNavigate } from "react-router-dom";
import { courseCategoryList, listPlayer, addCourse } from '../../../http/modules/organization'
import Oss from '../../../components/ossUpload/oss'
import './index.scss'
const { Option } = Select;


export default function ApplyAdd() {

  const [form] = Form.useForm();

  const navigate = useNavigate();

  // 课程类型
  const [radioValue, setRadioValue] = useState('标准课程');
  // 省
  const [province, setProvince] = useState('');
  // 是否可以提交
  const [disabled, setDisabled] = useState(true)
  // 课程类别
  const [categoryList, setCategoryList] = useState()
  // 参赛老师
  const [playerlist, setPlayerlist] = useState()
  // 主课程Url
  const [mainCourseUrl, setMainCourseUrl] = useState()
  // 主课程文件名称
  const [mainCourseName, setMainCourseName] = useState()
  // 说课Url
  const [subCourseUrl, setSubCourseUrl] = useState()
  // 说课文件名称
  const [subCourseName, setSubCourseName] = useState()
  // 报名表Url 
  const [formUrl, setFormUrl] = useState()
  // 报名表文件名称 
  const [formName, setFormName] = useState()
  // 课程类别
  const [kclb, setKclb] = useState()
  // 课程名称
  const [title, setTitle] = useState()
  // 参赛者id
  const [playerID, setPlayerID] = useState()
  // 附件
  const [fuJian, setFuJian] = useState([])

  const [minTime,setMinTime] = useState(0)
  const [maxTime,setMaxTime] = useState(30000)

  // 附件列表
  const [fujianData, setfujianData] = useState()

  const onFuJian = (name, url) => {
    setFuJian(fuJian => [...fuJian, {
      "name": name,
      "url": url
    }]);
  }

  const onFinish = async (values) => {
    if(!formUrl){ 
      message.error('请上传申报表')
      return
    }

    const category = form.getFieldValue('category')
    if (!category) {
      message.error('请选择课程类别')
      return
    }
    // 仅当该一级类别存在二级标签时才校验
    if (currentSubList?.length) {
      if (!selectedSubs || selectedSubs.length < 1 || selectedSubs.length > 3) {
        message.error('请选择 1-3 个二级课程类别')
        return
      }
    }

    let id
    playerlist.map((item) => {
      if (item.name == playerID) {
        id = item.uuid
        return
      }
    })
    let type
    radioValue == '标准课程' ? type = 'standard' : type = 'short'
    const extra = form.getFieldsValue(["goal", "apply", "feature", "assist"])
    const res = await addCourse({
      'playerUUID': id,
      "title": title,
      "category": category,
      // 后端字段：subCates（二级标签）
      "subCates": currentSubList?.length ? selectedSubs : [],
      "typ": type,
      "mainCourseUrl": mainCourseUrl,
      "mainCourseName": mainCourseName,
      "subCourseUrl": subCourseUrl,
      "subCourseName": subCourseName,
      "formUrl": formUrl,
      "formName": formName,
      // New text fields (keep types aligned with infoCourse)
      "goal": extra.goal || '',
      "apply": extra.apply || '',
      "feature": extra.feature || '',
      "assist": extra.assist || '',
      "attachmentList": fuJian
    })
    if (res.code == 0) {
      message.success('上传成功')
      form.resetFields();
      navigate('/organization/applyList')
    } else {
      message.error(`添加失败${res.msg}`)
    }
  };

  //课程类别
  const onCourseCategoryList = async () => {
    const res = await courseCategoryList({})
    setCategoryList(res.data?.list)
  }
  //参赛者列表
  const OnListPlayer = async () => {
    const res = await listPlayer({
      "pageNo": 1,
      "pageSize": 10000,

    })
    setProvince(res.data?.list[0]?.pinyin)
    setPlayerlist(res.data?.list)
  }

  // 删除
  const remove = (id) => {
    // let a = fuJian?.map((item) => {
    //   if (item.name == id) {
    //     item.operate = 'delete'
    //   }
    //   return item
    // })
    // setFuJian(a)
    let a=[...fuJian]
    a?.splice(a.findIndex(item=>item.name==id),1)
    setFuJian(a)
  }
const [currentSubList, setCurrentSubList] = useState([]); // 当前选中一级的二级列表
const [selectedSubs, setSelectedSubs] = useState([]); // 选中的二级标签
  useEffect(() => {
    onCourseCategoryList()
    OnListPlayer()
  }, [])

  return (
    <div className='applyAdd'>
      <header>
        <p></p>
        新增申报
      </header>

      <Form
        labelCol={{
          span: 4,
        }}
        wrapperCol={{
          span: 18,
        }}
        layout="horizontal"
        form={form}
      >

        <Form.Item
          name="gender"
          label="授课人"
          rules={[
            {
              required: true,
              message: '请选择授课人!'
            },
          ]}
        >
          <Select
            placeholder="选择老师"
            allowClear
            onChange={(value) => setPlayerID(value)}
          >
            {playerlist?.map((item) => {
              return <Option key={item.uuid} value={item.name} disabled={item.courseCnt >= 3 ? true : false}>{item.name}</Option>
            })}
          </Select>
        </Form.Item>

        <Form.Item label="课程名称" name='title' rules={[
          {
            required: true,
            message: '请填写课程名称!'
          },]}>
          <Input onChange={(e) => setTitle(e.target.value)} />
        </Form.Item>

        <Form.Item
          label="课程类别"
          name="category"
          rules={[{ required: true, message: '请选择课程类别!' }]}
        >
          <Radio.Group
            value={kclb}
            onChange={(e) => {
              const value = e.target.value
              setKclb(value)
              form.setFieldsValue({ category: value })

              // 切换一级类别后，二级标签需要重新选择
              setSelectedSubs([])
              form.setFieldsValue({ subCates: [] })

              const current = categoryList?.find(i => i.name === value)
              setCurrentSubList(current?.subCateList || [])
            }}
            style={{ display: 'flex', flexWrap: 'wrap' }}
          >
            {categoryList?.map((item) => (
              <Radio style={{ fontSize: '18px' }} key={item.name} value={item.name}>
                {item.name}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label="二级课程类别"
          name="subCates"
          rules={[
            {
              validator: (_, list) => {
                // 仅当该一级类别存在二级列表时才要求选择
                if (!currentSubList?.length) return Promise.resolve()

                if (!list || list.length < 1) return Promise.reject('至少选择 1 个二级课程类别')
                if (list.length > 3) return Promise.reject('最多选择 3 个二级课程类别')
                return Promise.resolve()
              },
            },
          ]}
        >
          {currentSubList?.length ? (
            <Checkbox.Group
              value={selectedSubs}
              onChange={(vals) => {
                const next = vals.length > 3 ? vals.slice(0, 3) : vals
                setSelectedSubs(next)
                form.setFieldsValue({ subCates: next })
                if (vals.length > 3) message.warning('二级课程类别最多选择 3 个')
              }}
              style={{ display: 'flex', flexWrap: 'wrap', gap: 16, fontSize: 16 }}
            >
              {currentSubList?.map((sub) => (
                <Checkbox
                  key={sub}
                  value={sub}
                  disabled={selectedSubs.length >= 3 && !selectedSubs.includes(sub)}
                  style={{ fontSize: 16 }}
                >
                  {sub}
                </Checkbox>
              ))}
            </Checkbox.Group>
          ) : (
            <span style={{ color: '#999', fontSize: 16 }}>该类别无二级课程类别</span>
          )}
        </Form.Item>
        
        <Form.Item label="课程目标" name="goal" rules={[{ max: 500, message: '最多500字' }]}>
          <Input.TextArea rows={4} placeholder="请简要说明通过学习课程，预期掌握的理论、知识点，以及可提升的实操应用、能力素养等。" maxLength={500} showCount />
        </Form.Item>

        <Form.Item label="课程建设及应用情况" name="apply" rules={[{ max: 500, message: '最多500字' }]}>
          <Input.TextArea rows={4} placeholder="请简要说明课程主要内容、相关教材、教学方法、以及课程在实际应用、效果反馈等方面的应用情况。" maxLength={500} showCount />
        </Form.Item>

        <Form.Item label="课程特色与创新实践" name="feature" rules={[{ max: 500, message: '最多500字' }]}>
          <Input.TextArea rows={4} placeholder="请简要说明课程在教学内容、教学模式等方面的亮点特色，以及在实操、成果转化等方面创新实践举措。" maxLength={500} showCount />
        </Form.Item>

        <Form.Item label="教辅工具" name="assist" rules={[{ max: 500, message: '最多500字' }]}>
          <Input.TextArea rows={4} placeholder="请说明课程配套使用的教学辅助工具，如课件PPT、案例素材、练习题、视频音频、工具包等，简要列明类型及用途，如无可填“无”。" maxLength={500} showCount />
        </Form.Item>

        <Form.Item label="授课类型" name='typ' initialValue={'标准课程'} rules={[
          {
            required: true,
            message: '请选择授课类型!'
          },]}>
          <Radio.Group onChange={(e) =>{ 
            if(e.target.value=='标准课程'){
              setMinTime(0)
              setMaxTime(30000)
              setRadioValue(e.target.value);
            }else{
              setMinTime(0)
              setMaxTime(30000)
              setRadioValue(e.target.value);
            }
            }} defaultChecked={true}  value={radioValue}>
            <Radio style={{ fontSize: '18px' }} value="标准课程"> 标准课程（45分钟） </Radio>
            <Radio style={{ fontSize: '18px' }} value="短课程"> 短课程（15分钟） </Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item label="上传视频" valuePropName="fileList">
          <>
            <Oss ext={'mp4'}  minTime={minTime}  maxTime={maxTime} url={setMainCourseUrl} province={province} kclb={kclb} title={title} video={'video1'} Name={setMainCourseName} buttonName={`支持格式MP4--点击上传${radioValue}`} />
            {radioValue == '标准课程' ? <Oss minTime={0} ext={'mp4'} maxTime={maxTime} url={setSubCourseUrl} province={province} kclb={kclb} title={title} video={'video2'} Name={setSubCourseName} buttonName='支持格式MP4--时长(5分钟)--说课视频' /> : ''}

          </>
        </Form.Item>

        <Form.Item label="上传附件" valuePropName="fileList">
          <>
            <Oss url={setFormUrl} province={province} kclb={kclb} title={title} video={'baoming'} Name={setFormName} buttonName='上传申报表' />
            <div className='fujian'>
              {fuJian?.map((item) => {
                // if (item.operate) {
                //   return ''
                // } else {
                  return <p key={item.url}>
                    <span title={item.name} style={{ width: '70%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>名称:{item.name}</span> <span style={{ color: 'red' }}> <a href={item.url?.split("?")[0]}>附件下载</a> <span
                      style={{cursor:'pointer'}} onClick={() => remove(item.name)}>X</span></span>
                  </p>
                // }
              })}
              <Oss fuJian={fuJian} setfujianData={setfujianData} onFuJian={onFuJian} province={province} kclb={kclb} title={title} buttonName='教辅工具' />
            </div>
          </>
        </Form.Item>

        <Form.Item name="remember" valuePropName="checked" wrapperCol={{ offset: 4, span: 22 }}>
          <Checkbox style={{fontSize:'16px'}} onChange={(value) => setDisabled(!value.target.checked)}>本人承诺该课程可免费、公开向社会发布使用，视频课程不侵犯第三方知识产权，如有任何知识产权纠纷，由报送人承担全部责任。</Checkbox>
        </Form.Item>

        <Form.Item
          wrapperCol={{
            offset: 12,
            span: 12,
          }}>
          <Button  type="primary" htmlType="submit" disabled={disabled} onClick={onFinish} className='queDing' title= {disabled?'请先同意承诺':''}>
            确定
          </Button>
        </Form.Item>

      </Form>
    </div>
  )
}
